import { text } from './i18n/t.js'

/**
 * Hauptnavigation (Anf. 28/54).
 *
 * Sechs Reiter unter der Kopfzeile, in der Reihenfolge, in der man sie
 * braucht. Kalender, Aufgaben, Dateien, Fotos und Einstellungen liegen unter
 * „Mehr" — als sichtbare Liste, nicht in einem Wischmenü (Anf. 65).
 *
 * SOS steht bewusst NICHT hier drin. Es ist kein Bereich unter Bereichen,
 * sondern ein Knopf, der auf jedem Bildschirm sichtbar bleibt (`SOS_ITEM`,
 * gerendert in `App.tsx`) — in der Kopfzeile, zwischen dem Namen der App und
 * der Lupe. Wer ihn in diese Liste zurückschiebt, macht ihn beim Scrollen
 * unerreichbar.
 */

export const NAV_ITEMS = [
  { id: 'familie',  icon: '🏠', label: text('Familie') },
  { id: 'chat',     icon: '💬', label: text('Chats') },
  { id: 'anrufen',  icon: '📞', label: text('Anrufe') },
  { id: 'standort', icon: '📍', label: text('Standort') },
  { id: 'status',   icon: '❤️', label: text("Wie geht's?") },
  { id: 'mehr',     icon: '⋯',  label: text('Mehr') },
] as const

/** Immer sichtbar, nie in einem Menü (Anf. 28/61). */
export const SOS_ITEM = { id: 'sos', icon: '🚨', label: text('SOS') } as const

export type RouteId = (typeof NAV_ITEMS)[number]['id'] | typeof SOS_ITEM.id

/** Bereiche unter "Mehr" — vorhanden, aber nicht in der Reiterleiste. */
export const SECONDARY_ITEMS = [
  { id: 'suche',        icon: '🔍', label: text('Suchen') },
  { id: 'fotos',        icon: '📷', label: text('Fotos') },
  { id: 'dateien',      icon: '📁', label: text('Dateien') },
  { id: 'kalender',     icon: '📅', label: text('Kalender') },
  { id: 'aufgaben',     icon: '✅', label: text('Aufgaben') },
  { id: 'notizen',      icon: '📝', label: text('Notizen') },
  { id: 'mitglieder',   icon: '👪', label: text('Familie verwalten') },
  { id: 'einstellungen',icon: '⚙️', label: text('Einstellungen') },
] as const

/**
 * Zerlegt den Hash in Bereich und optionale Raum-ID.
 *
 * `#chat/<roomId>` gibt es seit Phase 8: `start-aktionen.ts` schreibt ihn,
 * wenn jemand auf der Familienseite auf „Nachricht" tippt. Gelesen hat ihn bis
 * hierher **niemand** — der Hash passte auf keinen Bereich, und die App fiel
 * auf die Familienseite zurück. Ein Tipp auf „Nachricht" führte also dorthin,
 * wo man schon war. Der Test dazu war grün, weil er die Rückrufe zählt und
 * nicht, wo man landet.
 */
export function routeLesen(hash: string): { bereich: string; raum: string | null } {
  const roh = hash.replace(/^#/, '')
  // Ein „?foto=1" hängt `start-aktionen.ts` an. Es gehört nicht zur ID.
  const [pfad] = roh.split('?')
  const teile = (pfad ?? '').split('/')
  const bereich = teile[0] ?? ''
  return { bereich, raum: teile[1] ?? null }
}
